
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensary-info/[slug]/reviews",
      function () {
        return require("private-next-pages/dispensary-info/[slug]/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensary-info/[slug]/reviews"])
      });
    }
  